import { useQuery } from '@tanstack/react-query';
import { sreOpenBugTrendApi } from '../lib/api/sre-open-bug-trend.js';
import { queryKeys } from '../lib/query-keys.js';
import type { SreOpenBugTrendParams } from '../types/sre-open-bug-trend.js';

/**
 * SRE 未完了バグ件数の増減と推移。集計単位（週次/月次）ごとに取得する。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business KPI画面のSREビュー用に、未完了バグ件数の増えた数・減った数・期間末の未完了件数を取得するフック
 * @graph-connects /kpi/sre-open-bug-trend [calls] SRE未完了バグ件数推移取得
 */
export function useSreOpenBugTrend(params: SreOpenBugTrendParams) {
  return useQuery({
    queryKey: queryKeys.sreOpenBugTrend.trend(params),
    queryFn: () => sreOpenBugTrendApi.getTrend(params),
  });
}
